/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Stores template information including filter settings and column settings for each report. Report Template belongs to a single venue
 */
export interface ReportTemplateUpdate { 
    /**
     * Name of the template. Unique with report_id + venue_ref_id.
     */
    reportTemplateName?: string;
    /**
     * Type of report.
     */
    reportId?: number;
    venueId?: string;
    /**
     * Can only have one default template for a venue and report.
     */
    isDefault?: boolean;
    /**
     * References user who created the template.
     */
    createdBy?: string;
}